<template>
  <div style="min-height: 100vh">
    <div
      class="q-pt-xl full-width full-height"
      style="
        background-color: #ffffffff !important;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      "
    >
      <img
        src="/statics/images/details.png"
        object-fit="cover"
        style="padding: 30px；height:500px; max-width:100%"
      />

      <div
        class="text-center"
        style="max-width: 50%; min-width:320px; padding: 1em; padding-top: 5%"
      >
        <div
          class="text-left"
          style="font-size: 45px; margin-bottom: 30px; margin-top: 30px"
        >
          {{$t('home.solution.title')}}
        </div>
        <div style="text-align: left; font-size: 20px; margin: auto">
          <p>
            {{$t('home.solution.p1')}}
          </p>
          <p>{{$t('home.solution.p2')}}</p>
        </div>
        <a-button href="/solution" class="more-info-button">{{$t('home.solution.more')}}</a-button>
      </div>
    </div>

    <div style="max-width: 1600px; margin: 0 auto; display:flex; flex-wrap:wrap; justify-content:space-evenly">
      <div style="width:320px" v-for="index in 5"
          :key="index"
          >
        <a-card
          class="q-pa-sm flex flex-center text-center box-shadow"
          style="margin: 20px; min-height: 320px"
        >
          <div>
            <battery v-if="index==1" fillColor="rgb(123 170 74)" size="110px" />
            <clock v-if="index==2" fillColor="rgb(123 170 74)" size="110px" />
            <bolt v-if="index==3" fillColor="rgb(123 170 74)" size="110px" />
            <thermometer v-if="index==4" fillColor="rgb(123 170 74)" size="110px" />
            <earth v-if="index==5" fillColor="rgb(123 170 74)" size="110px" />
            <div class="text-h2 text-theme">{{$t('home.solution.card'+index+'.title')}}</div>
          </div>

          <div class="text-left">
            {{$t('home.solution.card'+index+'.desc')}}
          </div>
        </a-card>
      </div>
      
    </div>
  </div>
</template>

<script>
import Battery from "vue-material-design-icons/Battery.vue";
import Bolt from "vue-material-design-icons/LightningBolt.vue";
import Thermometer from "vue-material-design-icons/Thermometer.vue";
import Earth from "vue-material-design-icons/Earth.vue";
import Clock from "vue-material-design-icons/Clock.vue";
export default {
  name: "Solution",
  components: {
    Battery,
    Bolt,
    Thermometer,
    Earth,
    Clock,
  },
};
</script>

<style scoped>
.more-info-button {
    float:left;
    width:160px;
    height:50px;
    font-size: 20px;
    line-height: 50px;
}

.more-info-button:hover {
    border-color: rgb(123 170 74) !important;
    color: rgb(123 170 74) !important;
}
</style>
